export default {
  APP_ERROR: 'APP_ERROR',
  SMS_PREVIEW_MODAL: 'SMS_PREVIEW_MODAL',
  SMS_SEND_SUCCESS_MODAL: 'SMS_SEND_SUCCESS_MODAL'
};
